import { useState, useEffect, useRef } from "react";
import { IconChevronDown } from "./Icons";

const TopBarFilter = ({ filters, filter, handleFilterChange }) => {
  const [tagsExpanded, setTagsExpanded] = useState(false);
  // For arrow-button scrolling on the tag chip strip (desktop & mobile)
  const tagStripRef = useRef(null);
  const [tagStripState, setTagStripState] = useState({ canLeft: false, canRight: false });

  // Recompute scroll-arrow visibility for the tag strip
  const updateTagStripState = () => {
    const el = tagStripRef.current;
    if (!el) return;
    const canLeft = el.scrollLeft > 4;
    const canRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 4;
    setTagStripState(prev =>
      prev.canLeft === canLeft && prev.canRight === canRight ? prev : { canLeft, canRight }
    );
  };

  useEffect(() => {
    updateTagStripState();
    const el = tagStripRef.current;
    if (!el) return;
    const onScroll = () => updateTagStripState();
    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", updateTagStripState);
    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", updateTagStripState);
    };
  }, [tagsExpanded]);

  const scrollTagStrip = (dir) => {
    const el = tagStripRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(160, el.clientWidth * 0.6), behavior: "smooth" });
  };


  return (
    <div className={`unified-filter-row ${tagsExpanded ? "expanded" : ""}`}>
      <div className="unified-filter-strip-wrap">
        {!tagsExpanded && tagStripState.canLeft && (
          <button
            type="button"
            aria-label="Scroll filters left"
            className="tag-strip-arrow tag-strip-arrow-left"
            onClick={() => scrollTagStrip(-1)}
          >
            <IconChevronDown style={{ transform: "rotate(90deg)" }} />
          </button>
        )}
        <div className="unified-filter-strip" ref={tagStripRef}>
          {filters.map(f => {
            // "All" is active only when neither a condition nor a tag is selected.
            // Other conditions are active when their key matches AND no tag is selected.
            const isActive = f.key == filter
            return (
              <button
                key={f.key}
                className={`filter-btn ${isActive ? "active" : ""}`}
                onClick={() => handleFilterChange(f.key)}
              >
                {f.label}
              </button>
            );
          })}
        </div>
        {!tagsExpanded && tagStripState.canRight && (
          <button
            type="button"
            aria-label="Scroll filters right"
            className="tag-strip-arrow tag-strip-arrow-right"
            onClick={() => scrollTagStrip(1)}
          >
            <IconChevronDown style={{ transform: "rotate(-90deg)" }} />
          </button>
        )}
      </div>
      {filters?.length > 6 && (
        <button
          type="button"
          className="tag-expand-toggle"
          onClick={() => setTagsExpanded(e => !e)}
        >
          {tagsExpanded ? "Show less" : "Show all"}
        </button>
      )}
    </div>
  )
}

export default TopBarFilter;